module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/kind_icons/streak-0058afc57ce8d607d56bbfa67c3fe56a.svg";